import { Col, Row, Typography } from 'antd';
import React, { useState } from 'react';
import { DisputeReviewFragmentType } from '@pay-bill/graphql';
import { DisputeFiles } from './dispute-files';
import { SimpleFileFragmentType } from '@common/graphql';
import { Icon } from '@common/components';
import { Colors } from '@common/tokens';

const { Text } = Typography;

export const DisputeFilesSection = ({
  dispute,
  hiddenFiles,
  canDeleteFiles,
  onDelete,
}: {
  dispute: DisputeReviewFragmentType;
  hiddenFiles?: SimpleFileFragmentType[];
  onDelete?: (file: SimpleFileFragmentType) => void;
  canDeleteFiles?: string;
}) => {
  const { organization, supplier } = dispute.files;
  const [visible, setVisible] = useState(
    supplier.length > 0 || organization.length > 0
  );

  return (
    <div className="DisputeFilesSection" style={{ width: '100%' }}>
      <FilesDropDownLine visible={visible} changeDropdown={setVisible} />

      {visible && (
        <div className="files-content">
          <Col span={24}>
            <Text strong>{dispute.supplier.name} File Attachments</Text>
            <DisputeFiles
              files={supplier}
              hiddenFiles={hiddenFiles}
              onDelete={canDeleteFiles === 'Supplier' ? onDelete : undefined}
            />
          </Col>
          <div style={{ padding: '8px 0px' }} />
          <Col span={24}>
            <Text strong>{dispute.organization.name} File Attachments</Text>
            <DisputeFiles
              files={organization}
              hiddenFiles={hiddenFiles}
              onDelete={
                canDeleteFiles === 'Organization' ? onDelete : undefined
              }
            />
          </Col>
        </div>
      )}
      <style jsx>{`
        .files-content {
          margin-top: 10px;
        }
      `}</style>
    </div>
  );
};

const FilesDropDownLine = ({
  visible,
  changeDropdown,
}: {
  visible: boolean;
  dropdownText?: string;
  changeDropdown: (value: boolean) => void;
}) => (
  <>
    <Row
      className="files-dropdown-line"
      onClick={() => changeDropdown(!visible)}
      align="middle"
    >
      <Col className="files-dropdown-icon">
        <Icon icon={visible ? 'chevronUp' : 'chevronDown'} kind="regular" />
      </Col>
      <Col className="files-dropdown-title">Attachments</Col>
    </Row>
    <style jsx>{`
      :global(.files-dropdown-line .files-dropdown-title) {
        color: ${Colors.elm};
        font-weight: 500;
        font-size: 16px;
      }
      :global(.files-dropdown-line .files-dropdown-icon) {
        color: ${Colors.elm};
        margin-right: 10px;
      }
      :global(.files-dropdown-line) {
        cursor: pointer;
      }
    `}</style>
  </>
);
